import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from '@fullyops/shared/material.module';
import { I18NextCapPipe } from 'angular-i18next';

export interface InstallationDeleteDialogData {
  equipmentName: string;
  companyName: string;
}

@Component({
  selector: 'fo-installation-delete-dialog',
  imports: [MaterialModule, I18NextCapPipe],
  templateUrl: './installation-delete-dialog.component.html',
  styleUrl: './installation-delete-dialog.component.scss',
})
export class InstallationDeleteDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) protected data: InstallationDeleteDialogData,
  ) {}
}
